// @ts-strict-ignore
import type { Ref, SetupContext } from 'vue'
import type { IToolingBaseComposableDataItem } from '../use-tooling-base/types'
import type {
  IToolingListComposableData,
  IToolingListComposableProps,
  IToolingListComposableViewData,
} from './types'
import { getCurrentInstance, ref } from 'vue'
import { CONTEXT_CONSTS } from '../../store/context/context.consts'
import { mapGetters } from '../utils'

export const dataFn = <DataItemType extends IToolingBaseComposableDataItem>(
  props: IToolingListComposableProps,
  ctx: SetupContext,
  viewData: IToolingListComposableViewData,
): IToolingListComposableData<DataItemType> => {
  const {
    proxy: { $store },
  } = getCurrentInstance()

  const { context } = mapGetters($store, CONTEXT_CONSTS.moduleName, {
    context: CONTEXT_CONSTS.getters.context,
  })

  const selection: Ref<Array<DataItemType>> = ref([])

  const loadingData: Ref<boolean> = ref<boolean>(false)

  const optionSelected: Ref<DataItemType> = ref(null)

  const strictMatching: Ref<boolean> = ref(
    context.value.strictMatching ?? viewData.defaultStrictMatchingValue ?? true,
  )

  return {
    selection,
    optionSelected,
    strictMatching,
    loadingData,
  }
}
